export const CLOUD_NAME = 'idemo';

export const sections = {
  UPLOAD_RESULTS: 'UPLOAD_RESULTS_SECTION',
  SOCIAL: 'SOCIAL_SECTION',
  NEWS: 'NEWS_SECTION',
  ECOMMERCE: 'EXCOMMERCE_SECTION'
};

export const applicationModes = {
  INDEX: 'index',
  DEFAULT: 'default',
  Q_AUTO: 'qa',
  G_AUTO: 'ga',
  MULTI_CDN: 'multi-cdn'
};

export const applicationRoutes = {
  INDEX: 'index',
  DEFAULT: 'default',
  Q_AUTO: 'auto-quality',
  G_AUTO: 'auto-gravity',
  MULTI_CDN: 'multi-cdn'
};


/** WEBPACK FOOTER **
 ** ./src/js/constants/index.js
 **/